/**
 * To do boards: today, this week, personal, ideas, and associate / second
 * shooters still to book.
 *
 * Order is a fractional sort_order, so moving an item writes one row: it takes
 * the midpoint between its new neighbours.
 */

export type TodoList = 'today' | 'week' | 'personal' | 'ideas' | 'crew'

export const TODO_LISTS: Array<{ key: TodoList; title: string; empty: string }> = [
  { key: 'today', title: 'Today', empty: 'Nothing for today yet.' },
  { key: 'week', title: 'This week', empty: 'Things to do soon, not necessarily today.' },
  { key: 'personal', title: 'Personal', empty: 'Life outside the business.' },
  { key: 'ideas', title: 'Ideas', empty: 'Write it down now, do it later.' },
  { key: 'crew', title: 'Associate / second shooters', empty: 'Weddings that still need a shooter booked.' },
]

export interface Ordered {
  id: string
  sort_order: number
}

/**
 * The sort_order for an item dropped at `index` in `list` (the list without
 * the item itself).
 */
export function sortOrderAt(list: Ordered[], index: number): number {
  const before = list[index - 1]
  const after = list[index]
  if (!before && !after) return 0
  if (!before) return after!.sort_order - 1
  if (!after) return before.sort_order + 1
  return (before.sort_order + after.sort_order) / 2
}

/** Open items first in their order, ticked ones after (most recently ticked first). */
export function arrangeTodos<T extends Ordered & { done_at: string | null }>(items: T[]): T[] {
  const open = items.filter((item) => !item.done_at).sort((a, b) => a.sort_order - b.sort_order)
  const done = items.filter((item) => item.done_at).sort((a, b) => (b.done_at ?? '').localeCompare(a.done_at ?? ''))
  return [...open, ...done]
}
